module.exports = __webpack_public_path__ + "static/media/certified-transportation-icon.4dfc8b73.svg";